/* eslint-disable @typescript-eslint/no-empty-interface */
import { camel } from "./caseHelpers";

type Value =
  | IValueObject
  | IValueArray
  | Date
  | string
  | number
  | boolean
  | null;
interface IValueObject extends Record<string, Value> {}
interface IValueArray extends Array<Value> {}

/**
 * Recursively convert all object keys inside a data structure to camelCase.
 *
 * This is useful SPECIFICALLY and ONLY for converting the legacy HighGround
 * return types (pascal case) to the standard TypeScript and GraphQL form.
 */
export default function pascalKeysToCamelKeys<T extends Value>(value: T): T {
  if (value == null || typeof value !== "object") {
    return value;
  } else if (Array.isArray(value)) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value.map(pascalKeysToCamelKeys) as T;
  }

  const camelObject: Partial<T> = {};
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return Object.entries(value as IValueObject).reduce(
    (camelObject, [key, keyValue]) => {
      const camelKey = camel(key);
      const camelValue = pascalKeysToCamelKeys(keyValue);
      return Object.assign(camelObject, { [camelKey]: camelValue });
    },
    camelObject
  ) as T;
}
